<div>
  <p [hidden]="!isLostModeEnabled()">
    <small class="text-muted">The device is currently in Lost Mode.</small>
  </p>

  <ml-mdm-command-spinner [commandProgress]="commandProgressInformation$">
    <ml-mdm-command-spinner [commandProgress]="commandProgress$">
      @if (!isLostModeEnabled()) {
        <form [formGroup]="enableLostModeForm"
              (ngSubmit)="onSubmit()"
              novalidate>
          @if (success && enableLostModeForm.pristine) {
            <div class="callout-success text-success bg-white"
                 role="alert"
                 i18n>
              The device has been successfully set to lost mode.
            </div>
          }
          <div class="mb-3">
            <label class="form-label"
                   for="LostModeMessage"
                   i18n>Message:</label>
            <input id="LostModeMessage"
                   type="text"
                   class="form-control"
                   formControlName="lostModeMessage"
                   [class.is-invalid]="lostModeMessage?.invalid && lostModeMessage?.touched" />
            @if (lostModeMessage?.invalid && lostModeMessage?.touched) {
              <div class="invalid-feedback">
                @if (lostModeMessage?.errors?.required) {
                  <div>A message is required.</div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label class="form-label"
                   for="LostModePhoneNumber"
                   i18n>Phone number:</label>
            <input id="LostModePhoneNumber"
                   type="text"
                   class="form-control"
                   formControlName="lostModePhoneNumber"
                   [class.is-invalid]="lostModePhoneNumber?.invalid && lostModePhoneNumber?.touched" />
            @if (lostModePhoneNumber?.invalid && lostModePhoneNumber?.touched) {
              <div class="invalid-feedback">
                @if (lostModePhoneNumber?.errors?.required) {
                  <div>A phonenumber is required.</div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label class="form-label"
                   for="LostModeFootnote"
                   i18n>Footnote:</label>
            <input id="LostModeFootnote"
                   type="text"
                   class="form-control"
                   formControlName="lostModeFootnote"
                   [class.is-invalid]="lostModeFootnote?.invalid && lostModeFootnote?.touched" />
            @if (lostModeFootnote?.invalid && lostModeFootnote?.touched) {
              <div class="invalid-feedback">
                @if (lostModeFootnote?.errors?.required) {
                  <div>A footnote is required.</div>
                }
              </div>
            }
          </div>
          <button type="submit"
                  class="btn btn-primary"
                  [disabled]="enableLostModeForm.pristine"
                  i18n>
            Enable lost mode
          </button>
        </form>
      }
    </ml-mdm-command-spinner>
  </ml-mdm-command-spinner>
</div>